module.exports = __webpack_public_path__ + "static/media/laundry 1.5ae8b454.jpeg";